import React from "react";
import { Link, useParams } from "react-router-dom";
import useAppContext, { ACCOUNT_TYPES } from "state/AppContext";

export default function EmployerMainNav() {
  const appContext = useAppContext();
  const { account } = appContext;
  const { accountType } = account;
  const { recruiterUsername, clientUsername } = useParams();
  const baseURL = `/recruiters/${recruiterUsername}/employers/${clientUsername}`;
  const allRoutes = {
    employerPrivate: {
      dashboardRoute: `${baseURL}`,
      notificationsRoute: `${baseURL}/notifications`,
      ordersRoute: `${baseURL}/orders`,
      settingsRoute: `${baseURL}/settings`,
    },
    employerPublic: {
      dashboardRoute: "/",
      notificationsRoute: "/notifications",
      ordersRoute: "/orders",
      settingsRoute: "/settings",
    },
  };
  const routes = accountType === ACCOUNT_TYPES.EMPLOYER_PUBLIC ? allRoutes.employerPublic : allRoutes.employerPrivate;
  const navStyle = "block text-blue-700 hover:text-blue-800 mr-6 text-sm";

  return (
    <div className="z-10 fixed top-0 left-0 w-full h-[50px] bg-white border-b border-b-gray-300 px-4 py-2 flex justify-between">
      <ul className="flex items-center">
        <Link className={navStyle} to={routes.dashboardRoute}>
          Employer Dashboard
        </Link>
        <Link className={navStyle} to={routes.notificationsRoute}>
          Notifications
        </Link>
        <Link className={navStyle} to={routes.ordersRoute}>
          Orders
        </Link>
        <Link className={navStyle} to={routes.settingsRoute}>
          Settings
        </Link>
      </ul>
    </div>
  );
}
